import { atom, useAtom } from "jotai";
import { StoreItem } from "types";

export type StoreItemsState = {
  activeItem: any | null;
};

type UseStoreStateReturn = {
  storeState: StoreItemsState;
  setStoreState: React.Dispatch<React.SetStateAction<StoreItemsState>>;
};

export const storeStateAtom = atom<StoreItemsState>({
  activeItem: null,
});

export const storesAtom = atom<StoreItem[]>([]);

export const useStoreState = (): UseStoreStateReturn => {
  const [storeState, setStoreState] = useAtom(storeStateAtom);

  return { storeState: storeState, setStoreState };
};
